import React from "react";
import SuperAdminForm from "./SuperAdminForm";
import { useMutation, useQuery } from "react-query";
import { createErrors } from "../../../queries/helpers";
import PropTypes from "prop-types";
import {
  loadSuperAdmin,
  updateSuperAdmin,
} from "../../../queries/admin/superAdmin";
import { matchPath } from "react-router-dom";
import { useErrorHandler } from "react-error-boundary";

const EditSuperAdminPage = ({ history, toast }) => {
  const handleError = useErrorHandler();
  const superAdminId = matchPath(location.pathname, {
    path: "/super-admins/:id/edit",
    exact: true,
  })?.params.id;

  const {
    isLoading,
    isError,
    data: superAdmin,
  } = useQuery(
    ["organization", superAdminId],
    async () =>
      loadSuperAdmin(superAdminId)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          handleError(error);
        }),
    { enabled: !!superAdminId }
  );

  const editSuperAdmin = useMutation(async (formData) => {
    await updateSuperAdmin(formData, superAdminId);
  });

  const onSubmit = async (values) => {
    values["password_confirmation"] = values.password;
    return await editSuperAdmin
      .mutateAsync(values)
      .then(() => {
        toast.success([
          {
            title: "Super Admin has been updated",
            body: values.fullName,
          },
        ]);
        history.push("/super-admins");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to update super admin",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        createErrors(error, "Failed to update super admin", handleError);
      });
  };
  return (
    <>
      {!isLoading && !isError && (
        <SuperAdminForm onSubmit={onSubmit} superAdmin={superAdmin} />
      )}
    </>
  );
};

EditSuperAdminPage.propTypes = {
  history: PropTypes.object.isRequired,
  toast: PropTypes.func.isRequired,
};

export default EditSuperAdminPage;
